import {
  activateCapability,
  createCapability,
  deactivateCapability,
  fetchActiveCapabilities,
  fetchCapabilities,
  updateCapability,
} from "@/ServerActions/capabilities";
import { Capability, DataResponse } from "@/types";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

export const useCapability = (cancelState = true) => {
  return useQuery<DataResponse<Capability[]>>({
    queryKey: ["capability-list", "DotAdmin"],
    queryFn: () => fetchCapabilities(),
    enabled: cancelState,
  });
};

export const useActiveCapability = (cancelState = true) => {
  return useQuery<DataResponse<Capability[]>>({
    queryKey: ["capability-active-list", "DotAdmin"],
    queryFn: () => fetchActiveCapabilities(),
    enabled: cancelState,
  });
};

export const useEditCapabilities = () => {
  const queryClient: any = useQueryClient();
  return useMutation({
    mutationFn: updateCapability,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["capability-list", "DotAdmin"],
      });

      queryClient.invalidateQueries({
        queryKey: ["capability-active-list", "DotAdmin"],
      });
    },
    onError: (error) => {
      console.log(error);
    },
  });
};

export const useEnableCapability = () => {
  const queryClient: any = useQueryClient();
  return useMutation({
    mutationFn: activateCapability,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["capability-list", "DotAdmin"],
      });

      queryClient.invalidateQueries({
        queryKey: ["capability-active-list", "DotAdmin"],
      });
    },
    onError: (error) => {
      console.log(error);
    },
  });
};

export const useDisableCapability = () => {
  const queryClient: any = useQueryClient();
  return useMutation({
    mutationFn: deactivateCapability,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["capability-list", "DotAdmin"],
      });

      queryClient.invalidateQueries({
        queryKey: ["capability-active-list", "DotAdmin"],
      });
    },
    onError: (error) => {
      console.log(error);
    },
  });
};

export const useAddCapabilities = () => {
  const queryClient: any = useQueryClient();
  return useMutation({
    mutationFn: createCapability,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["capability-list", "DotAdmin"],
      });

      queryClient.invalidateQueries({
        queryKey: ["capability-active-list", "DotAdmin"],
      });
    },
    onError: (error) => {
      console.log(error);
    },
  });
};
